var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H17.5V1.0855C17.5 0.486 17.014 0 16.4145 0H7.5855C6.986 0 6.5 0.486 6.5 1.0855V4H0V6H2.335L4.335 21.3865C4.5295 22.8815 5.803 24 7.31 24H16.69C18.1975 24 19.4705 22.8815 19.665 21.3865L21.665 6H24V4ZM8.5 2H15.5V4H8.5V2ZM17.6815 21.129C17.617 21.6255 17.1905 22 16.69 22H7.31C6.809 22 6.383 21.6255 6.3185 21.129L4.352 6H19.6485L17.6815 21.129Z",
    fill: "#031434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5025 7.91822L13.503 19.9176L15.496 20.0836L16.4955 8.08422L14.5025 7.91822Z",
    fill: "#031434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49571 7.91682L7.50271 8.08282L8.50215 20.0822L10.4952 19.9162L9.49571 7.91682Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete_outline.5085c9bb02c2f805480fbebb56f239e7.svg";
export { ForwardRef as ReactComponent };